import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { ArrowLeft } from "lucide-react";
import Header from "@/components/landing/Header";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const META = {
  "terminos":     { key: "terms_md",   title: "Términos y Condiciones", kicker: "◊ Documentos legales" },
  "privacidad":   { key: "privacy_md", title: "Política de Privacidad", kicker: "◊ Documentos legales" },
  "cookies":      { key: "cookies_md", title: "Política de Cookies",    kicker: "◊ Documentos legales" },
  "politica-uso": { key: "policy_md",  title: "Política de Uso",        kicker: "◊ Documentos legales" },
};

/** Minimal markdown renderer — covers what we need (h1-h3, ul, p, strong, em). */
function renderMd(md) {
  if (!md) return null;
  const blocks = md.split(/\n\n+/);
  return blocks.map((b, i) => {
    const stripped = b.trim();
    if (stripped.startsWith("# ")) return <h1 key={i} className="font-serif text-4xl md:text-5xl tracking-tight mt-2 mb-4">{stripped.slice(2)}</h1>;
    if (stripped.startsWith("## ")) return <h2 key={i} className="font-serif text-2xl md:text-3xl tracking-tight mt-8 mb-3">{stripped.slice(3)}</h2>;
    if (stripped.startsWith("### ")) return <h3 key={i} className="font-serif text-xl mt-6 mb-2">{stripped.slice(4)}</h3>;
    if (/^[-*] /.test(stripped)) {
      const items = stripped.split("\n").map((l) => l.replace(/^[-*✓✗] /, "").trim()).filter(Boolean);
      return <ul key={i} className="list-disc list-inside space-y-1 my-3 text-sm leading-relaxed">{items.map((it, j) => <li key={j} dangerouslySetInnerHTML={{ __html: inline(it) }} />)}</ul>;
    }
    return <p key={i} className="text-sm md:text-base leading-relaxed my-3" dangerouslySetInnerHTML={{ __html: inline(stripped.replace(/\n/g, "<br>")) }} />;
  });
}

function inline(s) {
  return s
    .replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>")
    .replace(/\*(.+?)\*/g, "<em>$1</em>")
    .replace(/`(.+?)`/g, "<code class='font-mono text-[0.9em] bg-cream-deep px-1 rounded'>$1</code>");
}

export default function LegalPage({ kind = "terminos" }) {
  const meta = META[kind] || META["terminos"];
  const [md, setMd] = useState("");
  useEffect(() => {
    axios.get(`${API}/legal`).then((r) => setMd(r.data?.[meta.key] || "")).catch(() => {});
  }, [meta.key]);
  return (
    <main className="bg-cream text-ink min-h-screen">
      <Header />
      <div className="max-w-3xl mx-auto px-6 md:px-12 pt-32 md:pt-40 pb-20">
        <Link to="/" data-testid="legal-back" className="inline-flex items-center gap-1 text-xs text-ink-mid hover:text-coral mb-6">
          <ArrowLeft className="w-3.5 h-3.5" /> Volver al inicio
        </Link>
        <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-coral mb-2">{meta.kicker}</p>
        <article data-testid={`legal-${kind}`} className="prose prose-stone max-w-none">
          {renderMd(md) || <p className="text-ink-mid">Cargando…</p>}
        </article>
        <nav className="mt-12 pt-8 border-t hairline flex flex-wrap gap-3 text-xs text-ink-mid">
          <Link to="/legal/terminos" className="hover:text-coral underline">Términos</Link>
          <Link to="/legal/privacidad" className="hover:text-coral underline">Privacidad</Link>
          <Link to="/legal/cookies" className="hover:text-coral underline">Cookies</Link>
          <Link to="/legal/politica-uso" className="hover:text-coral underline">Política de Uso</Link>
          <Link to="/mision-vision-valores" className="hover:text-coral underline">Misión, Visión y Valores</Link>
        </nav>
      </div>
    </main>
  );
}
